import moment from 'moment'

export function formatoFecha (valor, salida, entrada) {
  let _salida = salida || 'DD/MM/YYYY'
  let _entrada = entrada || 'YYYY-MM-DD'

  if (valor) {
    return moment(valor.substr(0, 10), _entrada).format(_salida)
  } else {
    return null
  }
}

export function formatoHora (valor, salida, entrada) {
  let _salida = salida || 'h:mm'
  let _entrada = entrada || 'h:mm:ss'

  if (valor) {
    return moment(valor.substr(0, 8), _entrada).format(_salida)
  } else {
    return null
  }
}

export function fechaFutura (parametros) {
  let _parametros = parametros || {}
  let _formatoEntrada = _parametros.formatoEntrada || 'YYYY-MM-DD'
  let _formatoSalida = _parametros.formatoSalida || 'DD/MM/YYYY'
  let _parte = _parametros.parte || 'days'
  let _cantidad = _parametros.cantidad || 1
  let _fecha = _parametros.fecha || moment().format(_formatoEntrada)

  return moment(_fecha, _formatoEntrada).add(_cantidad, _parte).format(_formatoSalida)
}

export function fechaLocal (salida) {
  let _salida = salida || 'DD/MM/YYYY'

  return moment().format(_salida)
}

export function nombreCentro (item) {
  let nombre = item.codigo ? item.codigo.concat(' - ').concat(item.nombre) : item.nombre
  /*
  if (item.padre) {
    nombre = nombre
      .concat(' (')
      .concat(item.padre.nombre)
      .concat(')')
  }
  */
  return nombre
}

export function cabeceraComprobante (item, formato) {
  let _formato = formato || {}

  _formato.tipo = _formato.tipo ? _formato.tipo : 'nombre'
  _formato.letra = typeof _formato.letra !== 'undefined' ? _formato.letra : true

  let salida = item.tipo_comprobante[_formato.tipo]

  if (_formato.letra) {
    salida = salida.concat(' ').concat(item.tipo_comprobante_categoria.nombre)
  }

  salida = salida.concat(': ').concat(pad(item.punto_venta.numero, 4)).concat(' - ')
    .concat(item.numero_comprobante ? pad(item.numero_comprobante, 6) : 'S/N')

  return salida
}

export function cabeceraComprobanteAbreviado (item, formato) {
  let _formato = formato || {}

  _formato.tipo = _formato.tipo ? _formato.tipo : 'codigo'
  _formato.letra = typeof _formato.letra !== 'undefined' ? _formato.letra : true

  let salida = item.tipo_comprobante[_formato.tipo]

  if (_formato.letra) {
    salida = salida.concat(' ').concat(item.tipo_comprobante_categoria.nombre)
  }

  salida = salida.concat(': ').concat(pad(item.punto_venta.numero, 4)).concat(' - ')
    .concat(item.numero_comprobante ? pad(item.numero_comprobante, 6) : 'S/N')

  return salida
}

export function dni (item) {
  item = item.split('')
  item = item.reverse()

  item.splice(3, 0, '.')
  item.splice(7, 0, '.')

  item.reverse()
  return item.join('')
}

export function moneda (valor) {
  return String(valor).replace(',', ',')
}

export function strNbr (valor, laravel) {
  if (laravel) {
    return Number(valor)
  }
  return Number(valor.replace('.', '').replace(',', '.'))
}
export function nbrStr (valor, laravel) {
  return String(valor.toFixed(2))
}

export function ultDiaMes (parametros) {
  let _parametros = parametros || {}
  let _formatoEntrada = _parametros.formatoEntrada || 'YYYY-MM-DD'
  let _formatoSalida = _parametros.formatoSalida || 'DD/MM/YYYY'
  let _fecha = parametros.fecha || moment().format(_formatoEntrada)

  return moment(_fecha, _formatoEntrada).endOf('month').format(_formatoSalida)
}
function pad (n, width, z) {
  z = z || '0'
  n = n + ''
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
}

export function nombreMes (numero, lowercase) {
  let meses = {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre'
  }

  if (lowercase) {
    return meses[numero].toLowerCase()
  } else {
    return meses[numero]
  }
}

export function estadoFactura (item, formato) {
  let estado = ''

  switch (item.codigo) {
    case 'abierto':
      estado = 'A'
      break
    case 'en_proceso':
      estado = 'EP'
      break
    case 'pendiente':
      estado = 'P'
      break
    case 'prefacturado':
      estado = 'PF'
      break
    case 'facturado':
      estado = 'F'
      break
    case 'compensado':
      estado = 'CO'
      break
    case 'pago_parcial':
      estado = 'PP'
      break
    case 'cerrado':
      estado = 'C'
      break
    case 'error':
      estado = 'E'
      break
  }
  return estado
}
